<template>
  <Modal v-model="modal" :title="$t('btn.b86')" :mask-closable="false">
    <div>
      <Row :gutter="56">
        <Col span="13" class="borderRight">
          <div class="marb num">
            <Input :value="am1" readonly>
              <span slot="append" class="f14">{{$t('label.w5')}}</span>
            </Input>
            <span class="warning" v-show="assets.AvailableAmount<am1">{{$t('msg.m98')}}</span>
          </div>
          <div class="num">
            <p class="del" v-if="coupon">
              <span class="ps"><span>{{am2}}</span> 0</span>
              <span class="f14 ap">{{$t('label.w5')}}</span>
            </p>
            <Input :value="am2" readonly v-else>
              <span slot="append" class="f14">{{$t('label.w5')}}</span>
            </Input>
            <span class="warning" v-show="(assets.ManagementFeeAvailableAmount < am2) && !coupon">{{$t('msg.m98')}}</span>
          </div>
        </Col>
        <Col span="11">
          <div class="ye">
            <div>
              <span class="t">{{$t('label.w69')}}</span>
              <span class="m">{{assets.AvailableAmount | money}}{{$t('label.w5')}}</span>
            </div>
            <!-- <button @click="recharge">{{$t('btn.b44')}}</button> -->
            <span>
              <router-link target="_blank" :to="{name:'recharge'}" class="btn">{{$t('nav.w999')}}</router-link>
              <Icon type="ios-arrow-forward" />
            </span>
          </div>
          <div class="ye">
            <div>
              <span class="t">{{$t('label.w70')}}</span>
              <span class="m">{{assets.ManagementFeeAvailableAmount | money}}{{$t('label.w5')}}</span>
            </div>
            <!-- <button @click="rechargem">{{$t('btn.b44')}}</button> -->
            <span>
              <router-link
                target="_blank"
                :to="{name:'recharge',query:{type:'management'}}"
              >{{$t('nav.w999')}}</router-link>
              <Icon type="ios-arrow-forward" />
            </span>
          </div>
        </Col>
      </Row>
      <Coupon ref="coupon" :am2="am2" @on-change="onCouponChange" />
    </div>
    <template slot="footer">
      <Button
        type="primary"
        :disabled="btnRule"
        :loading="loading"
        @click="submit"
      >{{$t('btn.b43')}}</Button>
    </template>
  </Modal>
</template>
<script>
import { digitUppercase } from "@/libs/static";
import cookies from "vue-cookies";
import Coupon from './coupon'
export default {
  components: {
    Coupon
  },
  data() {
    return {
      modal: false,
      type: 1,
      item: {},
      loading: false,
      coupon: ''
    };
  },
  watch: {
    modal() {
      if (this.modal) {
        this.$refs.coupon.getCoupon()
      } else {
        this.$refs.coupon.off()
        this.coupon = ''
      }
    }
  },
  methods: {
    onCouponChange(v) {
      this.coupon = v
    },
    async submit() {
      this.loading = true;
      let arr = [] // 把订单与其多少期 整合
      this.item.list.forEach(v => {
        if (v.num > 0) {
          for (let i = 0; i < v.num; i++) {
            arr.push(v.loanSchemeId)
          }
        }
      })
      for (let k = 0; k < arr.length; k++) {
        let data = {
          loanSchemeId: arr[k],
          couponId: this.coupon
        }
        const res = await this.$axios.post("/Member/RZJLoan/CurrentPhaseRepay", data)
        if (k === (arr.length - 1)) {
          this.loading = false;
          this.$store.dispatch("user/getAssets");
          this.modal = false;
          this.$emit("done1");
          res.throw();
        }
      }
    }
    // recharge() {
    //   this.modal = false;
    //   this.$router.push({ name: "recharge", query: { type: "recharge" } });
    // },
    // rechargem() {
    //   this.modal = false;
    //   this.$router.push({ name: "recharge", query: { type: "management" } });
    // }
  },
  computed: {
    am1() {
      return this.item.PhaseAmount ? this.item.PhaseAmount.toFixed(2) : 0;
    },
    am2() {
      return this.item.PhaseManagementFee
        ? this.item.PhaseManagementFee.toFixed(2)
        : 0;
    },
    assets() {
      return this.$store.state.user.assets;
    },
    btnRule() {
      if (this.assets.AvailableAmount < this.am1) {
        return true
      } else if ((this.assets.ManagementFeeAvailableAmount < this.am2) && !this.coupon) {
        return true
      } else {
        return false
      }
    }
  }
};
</script>
<style lang="less" scoped>
.text {
  font-size: 14px;
  line-height: 20px;
}
.amount {
  line-height: 20px;
  color: #8f8f90;
  float: right;
  b {
    color: #ff6106;
    font-weight: normal;
  }
}
.marb {
  margin-bottom: 20px;
}
.f14 {
  font-size: 14px;
}
.num {
  position: relative;
  .warning {
    position: absolute;
    right: 35px;
    top: 12px;
    color: #f64750;
    z-index: 10;
  }
  .del {
    border-radius: 8px;
    line-height: 40px;
    border: 1px solid #f2f4f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    position: relative;
    top: 1px;
    .ps {
      padding: 4px 9px;
      font-size: 14px;
      color: #515a6e;
      span {
        text-decoration: line-through;
        margin-right: 10px;
      }
    }
    .ap {
      padding: 0 9px;
      font-weight: normal;
      line-height: 36px;
      color: #515a6e;
      text-align: center;
      background-color: #f2f4f9;
      border: 1px solid #f2f4f9;
      border-radius: 0 8px 8px 0;
      height: 100%;
    }
  }
}
.ye {
  display: flex;
  height: 40px;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  .t {
    color: #7b7b7c;
    display: block;
  }
  /deep/.ivu-icon {
    color: #2b85e4;
  }
  button {
    width: 44px;
    height: 26px;
    border-radius: 4px;
    border: 1px solid rgba(106, 152, 255, 1);
    color: rgba(106, 152, 255, 1);
    outline: none;
    cursor: pointer;
    padding: 0;
  }
}
.borderRight {
  border-right: solid 1px #f2f4f9;
}
</style>
